import { all, fork } from 'redux-saga/effects';
import rootNotificationSaga from './notifications.saga';

function* rootSaga() {
  yield all([fork(rootNotificationSaga)]);
}

export default rootSaga;
